<script setup lang="ts">
import { ref } from "vue";
import ToolTip from "../../ToolTip.vue";
import { locale } from "../../../locale";
import { exitFullScreenMode, fullScreenModeState, requestFullScreenMode } from "../../../states/fullScreenMode";
import RequestFullScreen24 from "../../icons/RequestFullScreen24.vue";
import ExitFullScreen24 from "../../icons/ExitFullScreen24.vue";
const btn = ref<HTMLElement | null>(null);
const click = () => {
  if (fullScreenModeState.value) {
    exitFullScreenMode();
  } else {
    requestFullScreenMode();
  }
};
</script>
<template>
  <button
    ref="btn"
    class="fullscreen-button"
    @click="click"
    :class="{
      active: fullScreenModeState,
    }"
  >
    <RequestFullScreen24 v-if="!fullScreenModeState" />
    <ExitFullScreen24 v-else />

    <ToolTip :placement="'top'" :reference="btn">{{
      fullScreenModeState ? locale.tooltips.exitFullscreen : locale.tooltips.enterFullscreen
    }}</ToolTip>
  </button>
</template>
<style scoped>
.fullscreen-button {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: var(--bottom-btn-off-bg-regular);
  color: var(--bottom-btn-off-content-regular);
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  cursor: pointer;
  color: white;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}

.fullscreen-button.error {
  cursor: default;
}

.fullscreen-button:hover:not(.error) {
  background-color: var(--bottom-btn-off-bg-hover);
  color: var(--bottom-btn-off-content-hover);
}

.fullscreen-button:active:not(.error) {
  background-color: var(--bottom-btn-off-bg-active);
  color: var(--bottom-btn-off-content-active);
}

.fullscreen-button:focus:not(.error) {
  outline: none;
}

.fullscreen-button.active:hover:not(.error) {
  background-color: var(--bottom-btn-on-bg-hover);
  color: var(--bottom-btn-on-content-hover);
}

.fullscreen-button.active:active:not(.error) {
  background-color: var(--bottom-btn-on-bg-active);
  color: var(--bottom-btn-on-content-active);
}

.fullscreen-button.active:not(.error) {
  background-color: var(--bottom-btn-on-bg-regular);
  color: var(--bottom-btn-on-content-regular);
}
</style>
